<template>
  <div>
    <h1 class="my-5 text-center">Данные организации</h1>

    <input-form-custom
      name="organization.brief"
      v-model="organization.brief"
      label="Краткое наименование"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.name"
      v-model="organization.name"
      label="Полное наименование"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.legal_address"
      v-model="organization.legal_address"
      label="Юридический адрес"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.actual_address"
      v-model="organization.actual_address"
      label="Фактический адрес"
    />
    <input-form-custom
      name="organization.inn"
      v-model="organization.inn"
      label="ИНН"
      rule="required|numeric|inn"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.ogrn"
      v-model="organization.ogrn"
      label="ОГРН"
      rule="required|numeric|ogrn"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.bank"
      v-model="organization.bank"
      label="Банк"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.bik"
      v-model="organization.bik"
      label="БИК"
      :rule="{
        required: true,
        numeric: true,
        regex: /^[0-9]{9}$/
      }"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.checking_account"
      v-model="organization.checking_account"
      label="Расчетный счет"
      :rule="{
        required: true,
        numeric: true,
        checking: organization.bik
      }"
    />
    <input-form-custom
      v-if="shortForm == false"
      name="organization.correspondent_account"
      v-model="organization.correspondent_account"
      label="Корреспондентский счет"
      :rule="{
        required: true,
        numeric: true,
        correspondent: organization.bik
      }"
    />
    <div class="form-group">
      <label>Система налогообложения</label>
      <v-multiselect
        v-model="organization.tax"
        :options="taxes"
        name="organization.tax"
        data-vv-as="Система налогообложения"
        v-validate="'required'"
      />
      <div v-if="errors.has('organization.tax')" class="invalid-feedback">
        {{ errors.first('organization.tax') }}
      </div>
    </div>
    <div class="form-group">
      <label>Ставка НДС в чеке</label>
      <v-multiselect
        v-model="organization.rate"
        :options="rates"
        name="organization.rate"
        data-vv-as="Ставка НДС в чеке"
        v-validate="'required'"
      />
      <div v-if="errors.has('organization.rate')" class="invalid-feedback">
        {{ errors.first('organization.rate') }}
      </div>
    </div>
    <input-form-custom
      v-if="shortForm == false"
      name="organization.email"
      v-model="organization.email"
      label="Электронная почта (контактная)"
      rule="required|email"
    />
    <div class="form-group">
      <label>Часовой пояс</label>
      <gmt-select
        v-model="organization.gmt"
        name="organization.gmt"
        data-vv-as="Часовой пояс"
        v-validate="'required'"
      />
      <div v-if="errors.has('organization.gmt')" class="invalid-feedback">
        {{ errors.first('organization.gmt') }}
      </div>
    </div>
  </div>
</template>

<script>
  import { Validator } from 'vee-validate'
  import isEqual from 'lodash/isEqual'

  export default {
    inject: {
      $validator: '$validator',
    },
    props: {
      value: {
        type: Object,
        default: () => ({}), 
      },
      shortForm: {
        type: Boolean,
        default: false, 
      },
    },
    data () {
      return {
        organization: this.value ? this.value : {},
        taxes: [
          'Общая (ОСН)',
          'Упрощенная доход (УСН доход)',
          'Упрощенная доход минус расход (УСН доход - расход)',
          'Единый налог на вмененный доход (ЕНВД)',
          'Единый сельскохозяйственный налог (ЕСН)',
          'Патентная система налогообложения (Патент)',
        ],
        rates: [
          'НДС 22%',
          'НДС 20%',
          'НДС 10%',
          'НДС расч. 20/120',
          'НДС расч. 10/110',
          'НДС 0%',
          'НДС не облагается',
          'НДС 5%',
          'НДС 7%',
          'НДС расч. 5/105',
          'НДС расч. 7/107',
        ],
      }
    },
    watch: {
      organization () {
        this.$emit('input', this.organization)
      },
      value () {
        if (!isEqual(this.value, this.organization)) {
          this.organization = this.value
        }
      },
    },
    mounted () {
      Validator.extend('inn', {
        getMessage: field => 'Некорректный ИНН.',
        validate: (value) => {
          if (value.match(/\D/)) {
            return false
          }
          if (value.length === 10) {
            let dgt10 = String(((
              2 * value[0] + 4 * value[1] + 10 * value[2] +
              3 * value[3] + 5 * value[4] + 9 * value[5] +
              4 * value[6] + 6 * value[7] + 8 * value[8]) % 11) % 10)
            if (value[9] == dgt10) {
              return true
            }
          } else if (value.length === 12) {
            let dgt11 = String(((
              7 * value[0] + 2 * value[1] + 4 * value[2] +
              10 * value[3] + 3 * value[4] + 5 * value[5] +
              9 * value[6] + 4 * value[7] + 6 * value[8] + 8 * value[9]) % 11) % 10)
            let dgt12 = String(((
              3 * value[0] + 7 * value[1] + 2 * value[2] +
              4 * value[3] + 10 * value[4] + 3 * value[5] +
              5 * value[6] + 9 * value[7] + 4 * value[8] +
              6 * value[9] + 8 * value[10]) % 11) % 10)
            if (dgt11 == value[10] && dgt12 == value[11]) {
              return true
            }
          }
          return false
        },
      })
      Validator.extend('ogrn', {
        getMessage: field => 'Некорректный ОГРН.',
        validate: (value) => {
          let dgt13
          if (value.match(/\D/)) {
            return false
          }
          if (value.length !== 13 && value.length !== 15) {
            return false
          }
          if (value.length === 13) {
            let num12 = value
            num12 = Math.floor((num12 / 10) % 11)
            if (num12 == 10) {
              dgt13 = 0
            } else {
              dgt13 = num12
            }
            if (value[12] == dgt13) {
              return true
            }
          }
          if (value.length === 15) {
            let num14 = value
            num14 = Math.floor((num14 / 10) % 13)
            let dgt15 = num14 % 10
            if (value[14] == dgt15) {
              return true
            }
          }
          return false
        },
      })
      Validator.extend('checking', {
        getMessage: field => 'Некорректный расчетный счет.',
        validate: (value, params) => {
          if (value.length === 20) {
            let bikRs = (params[0] || '000').slice(-3) + value
            let checksum = 0
            let coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
            for (let i in coefficients) {
              checksum += coefficients[i] * (bikRs[i] % 10)
            }
            if (checksum % 10 == 0) {
              return true
            }
          }
          return false
        },
      })
      Validator.extend('correspondent', {
        getMessage: field => 'Некорректный корреспондентский счет.',
        validate: (value, params) => {
          if (value.length === 20) {
            let bikKs = '0' + (params[0] ? params[0].slice(4, 6) : '00') + value
            let checksum = 0
            let coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1]
            for (let i in coefficients) {
              checksum += coefficients[i] * (bikKs[i] % 10)
            }
            if (checksum % 10 == 0) {
              return true
            }
          }
          return false
        },
      })
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/personal/organization.vue